module.exports = __webpack_public_path__ + "img/7.91c38e1c.png";